export function exists<T>(
  arg: T | undefined | null,
  message?: string
): asserts arg is T {
  if (typeof arg == "undefined" || arg === null)
    throw new Error(message || `Unexpected ${arg}`);
}
